import { DateTime } from "@bps/date-time";
import { RootStore } from "@stores/root/RootStore.ts";

export class ExportPatientRecordHelper {
  constructor(private root: RootStore) {}

  scheduleExportPatientRecordJob = async (patientId: string) => {
    const {
      practice: {
        ui: { exportRecordValues },
        scheduleExportPatientRecordJob
      }
    } = this.root;

    if (!exportRecordValues) {
      throw Error(
        "Export patient record values are not set. Cannot initiate export."
      );
    }

    if (!exportRecordValues.password) {
      throw Error(
        "Export patient record password are not set. Cannot initiate export."
      );
    }

    const demographicData = exportRecordValues.demographicData ?? [];
    const clinicalData = exportRecordValues.clinicalInformation ?? [];
    const startDate = DateTime.fromJSDate(exportRecordValues.startDate)
      ?.startOf("day")
      ?.toISO();

    const endDate = DateTime.fromJSDate(exportRecordValues.endDate)
      ?.endOf("day")
      .toISO();

    const templateNames = [
      "Patient Export-Header",
      "Patient Export-Demographic-General",
      ...demographicData,
      ...(clinicalData.length > 0
        ? ["Patient Export-Clinical-Header", ...clinicalData]
        : [])
    ];

    const templates = await this.root.document.getTemplates({
      names: templateNames
    });

    // Sort templates to match the order of 'templateNames'
    const sortedTemplateIds = templates
      .slice()
      .sort(
        (a, b) => templateNames.indexOf(a.name) - templateNames.indexOf(b.name)
      )
      .map(template => template.id);

    await scheduleExportPatientRecordJob(patientId, {
      startDate,
      endDate,
      includeConfidentialRecord: exportRecordValues.confidentialRecords,
      selectedTemplateIds: sortedTemplateIds,
      password: exportRecordValues.password
    });
  };
}
